export default "/static/build/believe.webp";